import { FC } from 'react'
import { useHistory } from 'react-router-dom'
import {
  IonButtons,
  IonHeader,
  IonRouterLink,
  IonTitle,
  IonToolbar,
} from '@ionic/react'

import { BackButton } from '@components/atoms/BackButton'
import { RemainingVoteCount } from '@components/atoms/RemainingVoteCount'
import { StatusBadge } from '@components/molecules/StatusBadge'

import { ContestStatus } from '@/enums'

interface IContestDetailsListHeaderProps {
  contestId: string
  contestName: string
  contestStatus: ContestStatus
}

export const ContestDetailsListHeader: FC<IContestDetailsListHeaderProps> = ({
  contestId,
  contestStatus,
  contestName,
}) => {
  const history = useHistory()

  return (
    <IonHeader>
      <IonToolbar
        mode="ios"
        className="fixed z-20 w-full contest-details bg-gradient-to-b from-black/40 border-0"
      >
        <IonButtons slot="secondary">
          <BackButton defaultHref={`/contest/${contestId}`} />
        </IonButtons>
        <IonButtons slot="primary">
          <RemainingVoteCount className="mr-[0.625rem]" />
        </IonButtons>
        <IonTitle class="text-center sm:px-12 pl-12 pr-20">
          <div className="flex justify-center items-center font-bold">
            {!!contestName && (
              <IonRouterLink
                onClick={() => history.replace(`/contest/${contestId}`)}
                className="truncate text-white cursor-pointer"
                title={`#${contestName}`}
              >
                {contestName}
              </IonRouterLink>
            )}
          </div>
          {contestStatus === ContestStatus.Finished && (
            <StatusBadge className="pl-2" status={contestStatus} />
          )}
        </IonTitle>
      </IonToolbar>
    </IonHeader>
  )
}
